import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
    // return Promise.reject(error.response);
  }
);

function GetAccidentCountReport(item) {
  return client.get("Reports/GetAccidentCountReport/" + item.startDate + "/" + item.endDate + "/" + item.pageNumber + "/" + item.pageSize + "/" + item.dataExport);

}

function GetBtzAccidentsReport(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
  return client.get("Reports/GetBtzAccidentsReport/" + item.startDate + "/" + item.endDate + "/" + item.searchType + "/" + item.searchText  + "/" + item.paymentStatus + "/" + item.accidentStatus + "/" + item.claimStatus +  "/" + item.zbtStatus  + "/" + item.pageNumber + "/" + item.pageSize + "/" + item.dataExport );
}
function GetAccidentDetails(item) {
  return client.get("Reports/GetAccidentDetails/" + item.startDate + "/" + item.endDate + "/" + item.pageNumber + "/" + item.pageSize + "/" + item.dataExport);
}
function GetAccidentDetailsFull(item) {
  return client.get("Reports/GetAccidentDetailsFull/" + item.startDate + "/" + item.endDate + "/"+ item.pageNumber + "/" + item.pageSize + "/" + item.dataExport);
}
export {
  GetAccidentCountReport,
  GetBtzAccidentsReport,
  GetAccidentDetails,
  GetAccidentDetailsFull
};
